// extracted by mini-css-extract-plugin
export var rateTable = "_3t-0";